/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/jsx-filename-extension */
import React, { useRef } from 'react';
import { Button,ButtonDesign } from '@ui5/webcomponents-react';
import eurekaMgrs from '@eureka/ui-managers';
import EurekaComponents from 'eureka';
import { css } from '@linaria/core';

const logoutFormContainer = css`
  height: 135px;
  padding: 0 0.2rem;
`;

const headerContainer = css`
  border-bottom: 0.0625rem solid var(--sapPageFooter_BorderColor, #d9d9d9);
  padding: 0 0.5rem;
`;

const contentContainer = css`
  padding: 1rem;
`;

const footerContainer = css`
  border-top: 0.0625rem solid var(--sapPageFooter_BorderColor, #d9d9d9);
  padding: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const { useTranslation } = EurekaComponents.I18nProvider;
const { getConfig } = eurekaMgrs.ConfigManager;

export default ({ eventBus }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { auth_provider, auth_method } = getConfig('user') || {};

  return (
    <div className={logoutFormContainer}>
      <header className={headerContainer}>
        <div>
          <h3>{t('Header_Confirmation')}</h3>
        </div>
      </header>
      <div className={contentContainer}>
        <div>
          <form ref={formRef} action="/auth/logout" method="post">
            <input type="hidden" name="auth_provider" value={auth_provider} />
            <input type="hidden" name="auth_method" value={auth_method} />
          </form>
          {t('Header_Logout_Confirmation')}
        </div>
      </div>
      <footer className={footerContainer}>
        <Button
          style={{ padding: '0 9px' }}
          onClick={() => {
            eventBus.emit('dialog-show-hide', '', {
              type: 'cancel',
              data: {
                showDialog: false,
              },
            });
          }}
          design={ButtonDesign.Transparent}
        >
          {t('Header_Logout_Btn_No')}
        </Button>
        <Button
          style={{ marginLeft: '10px', padding: '0 9px' }}
          design={ButtonDesign.Emphasized}
          onClick={() => {
            if (formRef.current) {
              setTimeout(() => {
                formRef.current.submit();
              }, 2000);
              eventBus.emit('dialog-show-hide', '', {
                type: 'confirm',
                data: {
                  showDialog: false,
                },
              });
            }
          }}
        >
          {t('Header_Logout_Btn_Yes')}
        </Button>
      </footer>
    </div>
  );
};
